export const API_ADDR = 'https://160.119.252.81:443';
//160.119.252.81:82 
//192.168.20.147
//10.0.0.4:443
//app.comstruct.co.za:443
//local vm //160.119.252.81:82
